import {
    BuckinghamshireRecordType,
    BuckinghamshireRecordSubType
} from "./BuckinghamshireRecordTypes";
import { IStyleFactory } from "esdm-map/dist/layers/vector/styles/IStyleFactory";
import Style, { StyleFunction } from "ol/style/Style";
import Fill from 'ol/style/Fill';
import Circle from 'ol/style/Circle';
import Stroke from 'ol/style/Stroke';
import RegularShape from "ol/style/RegularShape";
import * as olHas from 'ol/has';


export class HbsmrStyleFactory implements IStyleFactory {

    public getStyle(recordType: string, recordSubType: string = null): Style[]
    {
        let style: Style[] = null;

        //try and resolve sub type first
        if (recordSubType !== null) {
            switch (recordSubType) {               

                case BuckinghamshireRecordSubType.ListedBuilding:
                    style = this.ListedBuilding();
                    break;

                case BuckinghamshireRecordSubType.LocallyListedBuilding:
                    style = this.LocallyListedBuilding();
                    break;

                case BuckinghamshireRecordSubType.ScheduledMonument:
                    style = this.ScheduledMonument();
                    break;
                              
                case BuckinghamshireRecordSubType.RegisteredParksAndGardens:
                    style = this.RegisteredParksAndGardens();
                    break;

                case BuckinghamshireRecordSubType.ConservationArea:
                    style = this.ConservationArea();
                    break;

                case BuckinghamshireRecordSubType.ArchaeologicalNotificationAreas:
                    style = this.ArchaeologicalNotificationAreas();
                    break;
            }
        }

        if (style === null) {
            switch (recordType) {
                case BuckinghamshireRecordType.Monument:
                    style = this.Monument();
                    break;

                case BuckinghamshireRecordType.Event:
                    style = this.Event();
                    break;

                //case BuckinghamshireRecordType.Designation:
                //    style = this.Designation();
                //    break;

                case BuckinghamshireRecordType.Consultation:
                    style = this.Consultation();
                    break;
            }
        }

        return style;
    }

    public getSelectedStyle(
        recordType: string = BuckinghamshireRecordType.Monument): Style[]
    {        
        return this.SelectedRecord();
    }

  
    
    private Monument(): Style[] {    
        var fill = new Fill({
            color: 'rgba(56, 168, 0, 0.4)'
        });        
        var stroke = new Stroke({
            color: 'rgba(56, 168, 0, 1)',
            width: 2
        });
        return   [
            new Style({
                image: new Circle({                  
                    stroke: stroke,
                    radius: 5,
                    fill: fill
                }),           
                stroke: stroke,
                fill: fill
            })
        ];
    }

    private Event(): Style[] {       
        var fill = new Fill({
            color: 'rgba(153, 204, 255, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(153, 204, 255, 1)',
            width: 2
        });

        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 4,
                radius: 10,
                rotation: 0,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private ListedBuilding(): Style[] {
        var fill = new Fill({
            color: 'rgba(168, 0, 0, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(168, 0, 0, 1)',
            width: 2
        });

        return [new Style({
            image: new Circle({
                fill: fill,
                stroke: stroke,              
                radius: 10
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private LocallyListedBuilding(): Style[] {
        var fill = new Fill({
            color: 'rgba(138, 117, 0, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(138, 117, 0, 1)',
            width: 2
        });

        return [new Style({
            image: new Circle({
                fill: fill,
                stroke: stroke,
                radius: 10
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private Consultation(): Style[] {        
        var fill = new Fill({
            color: 'rgba(230, 0, 0, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(230, 0, 0, 1)',
            width: 2
        });

        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 3,
                radius: 10,                
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private ScheduledMonument(): Style[] {
        var fill = new Fill({
            color: 'rgba(230, 0, 0, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(230, 0, 0, 1)',
            width: 2
        });

        return [new Style({
            image: new Circle({
                fill: fill,
                stroke: stroke,
                radius: 10
            }),
            fill: fill,
            stroke: stroke
        })];
    }
    
    private RegisteredParksAndGardens(): Style[] {
        //return this.CommonStyle('rgba(45, 123, 9,0.5)');   
        var fill = new Fill({
            color: 'rgba(255, 115, 223, 0.4)'
        });

        var stroke = new Stroke({
            color: 'rgba(255, 115, 223, 1)',
            width: 2
        });
                
        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 4,
                radius: 10,                
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private ConservationArea(): Style[] {
        var fill = new Fill({
            color: 'rgba(222, 158, 102, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(222, 158, 102, 1)',
            width: 2
        });
       
        return [new Style({
            image: new Circle({
                fill: fill,
                stroke: stroke,
                radius: 10
            }),
            fill: fill,
            stroke: stroke
        })];
    }
    
    private ArchaeologicalNotificationAreas(): Style[] {
        var fill = new Fill({
            color: 'rgba(255, 255, 115, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(255, 255, 115, 1)',
            width: 2
        });

        return [new Style({
            image: new Circle({
                fill: fill,
                stroke: stroke,
                radius: 10
            }),
            fill: fill,
            stroke: stroke
        })];
    }
    
    private SelectedRecord(): Style[] {
        var fill = new Fill({
            color: 'rgba(255, 255, 0, 0.4)'
        });

        return [
            new Style({
                image: new Circle({
                    fill: fill,
                    stroke: new Stroke({
                        color: 'rgba(255, 173, 10, 1)',
                        width: 3
                    }),
                    radius: 10
                }),
                fill: fill,
                stroke: new Stroke({
                    color: 'rgba(255, 173, 10, 1)',
                    width: 3
                })
            })
        ];
    }

}
